import { z } from 'zod';
import { passwordRegex } from '../utils/util';

// Zod 스키마 정의
export const passwordChangeSchema = z
  .object({
    oldPassword: z
      .string()
      .min(8, { message: '비밀번호는 최소 8자입니다.' })
      .max(20, { message: '비밀번호는 최대 20자 입니다.' })
      .regex(passwordRegex, '비밀번호는 영문 + 숫자를 조합해야 합니다.'),
    newPassword: z
      .string()
      .min(8, { message: '비밀번호는 최소 8자입니다.' })
      .max(20, { message: '비밀번호는 최대 20자 입니다.' })
      .regex(passwordRegex, '비밀번호는 영문 + 숫자를 조합해야 합니다.'),
    newPasswordConfirm: z
      .string()
      .min(8, { message: '비밀번호 확인을 입력해주세요.' })
      .max(20, { message: '비밀번호는 최대 20자 입니다.' }),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirm, {
    path: ['newPasswordConfirm'],
    message: '비밀번호가 일치하지 않습니다.',
  });

export const phoneChangeSchema = z.object({
  phone: z
    .string()
    .min(10, { message: '휴대폰 번호는 최소 10자리입니다.' })
    .max(13, { message: '최대 11자까지 입력 가능합니다.' }),
  changedPhone: z
    .string()
    .min(10, { message: '휴대폰 번호는 최소 10자리입니다.' })
    .max(13, { message: '최대 11자까지 입력 가능합니다.' }),
});

export const carNoSchema = z.object({
  registrationFile: z
    .instanceof(File, { message: '자동차 등록증을 업로드해주세요.' })
    .nullable()
    .refine((file) => file !== null, {
      message: '자동차 등록증을 업로드해주세요.',
    }), // 파일 검증
});

export const companyUploadImgSchema = z.object({
  registrationFile: z
    .instanceof(File, { message: '사업자 등록증을 업로드해주세요.' })
    .nullable()
    .refine((file) => file !== null, {
      message: '사업자 등록증을 업로드해주세요.',
    }), // 파일 검증
});

export const searchItemSchema = z.object({
  searchItem: z.string().min(1, { message: '1자 이상 입력해주세요.' }),
});

export const delegationSchema = z.object({
  radioBtnItems: z.string().min(1, { message: '라디오 버튼을 선택해주세요.' }),
});

export const companyInfoChangedSchema = z
  .object({
    charge: z.string().nullable().optional(),
    position: z.string().nullable().optional(),
  })
  .refine((data) => data.charge || data.position, {
    message: '담당자 또는 직책 중 하나는 반드시 입력해야 합니다.',
    path: [], // 전체 오브젝트에 대한 메시지 표시
  });

export const driverAmountSchema = z.object({
  halfDay: z.number(),
  fullDay: z.number(),
  ryubei: z.number(),
  cycle: z.number(),
  freshWater: z.number(),
  wasteWater: z.number(),
  delay: z.number(),
});

export const companyStandardTaskSchema = z.object({
  halfDay: z.string(),
  fullDay: z.string(),
  etcCondition: z.string(),
  otCondition: z.string(),
  cycleCondition: z.string(),
  fuelSupport: z.boolean(),
});
